@import "@/ui/variables.css";

.cardRoot {
  --background: var(--backdrop);
  --header-background: var(--white);
  --border-color: var(--gray-lightest);
  --border-radius: var(--radius);

  background: var(--background);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  color: var(--gray);

  header {
    background: var(--header-background);
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
    padding: var(--space-1) var(--space-2) 0 var(--space-2);
    border-bottom: 1px solid var(--border-color);

    h1 {
      margin: 0;
    }
    p {
      margin: 0;
    }
  }

  footer {
    margin-top: var(--space-2);
    padding: var(--space-1) var(--space-2) 0 var(--space-2);
    background: var(--header-background);
    border-bottom-left-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
    padding: var(--space-1) var(--space-2);
    border-top: 1px solid var(--border-color);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &[data-tint="yellow"]:hover,
  &[data-tint="yellow"] {
    --border-color: oklch(from var(--yellow) calc(l - 0.2) c h);
    --header-background: color-mix(var(--yellow) 25%, var(--white));
    --background: color-mix(var(--yellow) 8%, var(--white));
  }

  &[data-tint="blue"]:hover,
  &[data-tint="blue"] {
    --border-color: oklch(from var(--blue) calc(l - 0.2) c h);
    --header-background: color-mix(var(--blue) 25%, var(--white));
    --background: color-mix(var(--blue) 8%, var(--white));
  }

  &[data-tint="green"]:hover,
  &[data-tint="green"] {
    --border-color: oklch(from var(--green) calc(l - 0.2) c h);
    --header-background: color-mix(var(--green) 25%, var(--white));
    --background: color-mix(var(--green) 8%, var(--white));
  }

  &[data-tint="red"]:hover,
  &[data-tint="red"] {
    --border-color: oklch(from var(--red) calc(l - 0.2) c h);
    --header-background: color-mix(var(--red) 25%, var(--white));
    --background: color-mix(var(--red) 8%, var(--white));
  }
}
